import {Button} from '@/components/ui/button/Button'
import {
    Dialog,
    DialogBody,
    DialogDisclosure,
    DialogHeader,
    DialogHeading,
    DialogProvider
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PrinterIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {StyledPrintFm22DialogFooter} from '@/features/projects/components/print-fm-22-dialog/style'
import {PrintFm22Trigger} from '@/features/projects/components/print-fm-22-trigger/PrintFm22Trigger'
import {OperatorSignatureField} from '@/features/projects/components/project-form/opertor-signature-field/OperatorSignatureField'
import {useFm22Window} from '@/features/projects/hooks/useFm22Window'
import {ProjectSmall} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {useDialogContext, useDialogStore} from '@ariakit/react'
import dayjs from 'dayjs'
import {useState} from 'react'

export const PrintFm22Dialog = ({project}: {project: ProjectSmall}) => {
    const {t} = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    const dialogStore = useDialogStore({
        open: isOpen,
        setOpen: setIsOpen
    })
    // Printing the FM22 follows the same windows as editing it (OPSSTD-1880/4462).
    const {canEditFm22} = useFm22Window(project)

    if (!canEditFm22) {
        return null
    }

    return (
        <DialogProvider store={dialogStore}>
            <DialogDisclosure
                render={
                    <Button variant="ghost" size="sm">
                        <PrinterIcon />
                        {t('projects:fm22_print')}
                    </Button>
                }
            />
            <Dialog width="400px">
                <PrintFm22DialogContent project={project} />
            </Dialog>
        </DialogProvider>
    )
}

const PrintFm22DialogContent = ({project}: {project: ProjectSmall}) => {
    const {t} = useTranslation()
    const [isSigned, setIsSigned] = useState(false)
    const dialog = useDialogContext()

    return (
        <>
            <DialogHeader>
                <Flexbox direction="column" gap={2}>
                    <DialogHeading>{t('projects:fm22_print')}</DialogHeading>
                    <Flexbox direction="column" gap={1}>
                        <Text size="textSm">
                            {t('projects:code_date', {
                                code: project.code,
                                date: dayjs(project.startDate).format('DD/MM/YYYY')
                            })}
                        </Text>
                        <Text size="textSm" palette="neutral" shade="500">
                            {t('commons:patient_fullname_value', {fullName: project.patient.fullName})}
                        </Text>
                    </Flexbox>
                </Flexbox>
            </DialogHeader>
            <DialogBody>
                <OperatorSignatureField isSigned={isSigned} setIsSigned={setIsSigned} />
            </DialogBody>
            <StyledPrintFm22DialogFooter>
                <Button variant="secondary" onClick={() => dialog?.setOpen(false)}>
                    {t('commons:close')}
                </Button>
                <PrintFm22Trigger onPrintSuccess={() => dialog?.setOpen(false)} />
            </StyledPrintFm22DialogFooter>
        </>
    )
}
